import type { ConfigCustomizacao } from '../tipos';

/**
 * Utilitários de customização visual por estabelecimento
 * Requisitos: 6
 */

export const CUSTOMIZACAO_PADRAO: ConfigCustomizacao = {
  urlLogo: '/logo-padrao.svg',
  nomeEstabelecimento: 'NexoGourmet',
  corPrimaria: '#1a1a2e',
  corSecundaria: '#16213e',
  corDestaque: '#e94560',
  corTexto: '#ffffff',
  corFundo: '#0f3460',
};

/**
 * Aplica as variáveis CSS de customização ao documento
 */
export const aplicarCustomizacao = (config: ConfigCustomizacao): void => {
  const raiz = document.documentElement;
  raiz.style.setProperty('--cor-primaria', config.corPrimaria);
  raiz.style.setProperty('--cor-secundaria', config.corSecundaria);
  raiz.style.setProperty('--cor-destaque', config.corDestaque);
  raiz.style.setProperty('--cor-texto', config.corTexto);
  raiz.style.setProperty('--cor-fundo', config.corFundo);
};

/**
 * Valida e retorna a customização, usando padrão se inválida
 */
export const obterCustomizacaoValida = (
  config: Partial<ConfigCustomizacao> | null | undefined
): ConfigCustomizacao => {
  if (!config) return CUSTOMIZACAO_PADRAO;

  return {
    urlLogo: config.urlLogo || CUSTOMIZACAO_PADRAO.urlLogo,
    nomeEstabelecimento: config.nomeEstabelecimento || CUSTOMIZACAO_PADRAO.nomeEstabelecimento,
    corPrimaria: config.corPrimaria || CUSTOMIZACAO_PADRAO.corPrimaria,
    corSecundaria: config.corSecundaria || CUSTOMIZACAO_PADRAO.corSecundaria,
    corDestaque: config.corDestaque || CUSTOMIZACAO_PADRAO.corDestaque,
    corTexto: config.corTexto || CUSTOMIZACAO_PADRAO.corTexto,
    corFundo: config.corFundo || CUSTOMIZACAO_PADRAO.corFundo,
  };
};
